const helpers = {
  groupSavedFilters(savedFilters) {
    return savedFilters.reduce((acc, item) => {
      const { type } = item;

      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(item);

      return acc;
    }, {});
  },
  updateActiveFilters({ type, filter, project_id, multiview_id }, activeFilters) {
    if (['workload', 'list', 'calendarview', 'boardview'].includes(type)) {
      if (!activeFilters[type]) {
        activeFilters[type] = {};
      }
      activeFilters[type][project_id || multiview_id || 'common'] = filter;
    } else {
      activeFilters[project_id || multiview_id || type] = filter;
    }

    return activeFilters;
  }
};

export default helpers;
